<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <SearchInspResultForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SearchInspResultForm from '@/components/organisms/terminal/form/SearchInspResultForm'

export default {
  name: 'SearchInspResultPage',

  components: { SearchInspResultForm },
}
</script>
